import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { IProfissional } from '../models/profissional.model';

@Injectable()
export class ProfissionalService extends EntityService<IProfissional> {
  constructor(protected configService: ConfigService) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'profissional',
      pluralBaseEntityEndPoint: 'profissionais'
    });
  }
}
